// Navigation tables shared by the rail, the phone tab bar, the phone drawer and
// the footer. One source so a label change lands everywhere.

export const APP_NAV = [
  { to: '/home', label: 'Home' },
  { to: '/you', label: 'You' },
  { to: '/log', label: 'Log' },
  { to: '/data', label: 'Data' },
  { to: '/insights', label: 'Insights' },
  { to: '/supplements', label: 'Supplements' },
];

// Phone bottom bar: five tabs, Home lives behind the wordmark.
export const APP_TABS = [
  { to: '/you', label: 'You' },
  { to: '/log', label: 'Log' },
  { to: '/data', label: 'Data' },
  { to: '/insights', label: 'Insights' },
  { to: '/supplements', label: 'Supps' },
];

export const MARKETING_NAV = [
  { to: '/', label: 'Overview' },
  { to: '/features/health-twin', label: 'How it works' },
  { to: '/features/predictions', label: 'Why trust it' },
  { to: '/quiz', label: 'Supplements' },
];

export const MARKETING_MORE = [
  { to: '/articles', label: 'Articles' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
  { to: '/privacy-policy', label: 'Privacy' },
  { to: '/terms-of-service', label: 'Terms' },
];

export const FOOTER_LINKS = [
  { to: '/privacy-policy', label: 'Privacy' },
  { to: '/terms-of-service', label: 'Terms' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

// Active when the path is the link or a child of it ("/me/devices" lights "/me").
export const isActivePath = (pathname, to) =>
  to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(`${to}/`);
